/**
 * Loading-skeleton styling, rebuilt in Tailwind when `utilities/_ub-skeleton.scss`
 * was retired (DEV-6560).
 *
 * The shimmer is an `::after` sweep rather than a background-position animation
 * so it composites on the GPU. `--sk` / `--sk-shine` exist so the gradient is
 * written once and only the two colours change between the light and dark
 * themes.
 */
const SHINE_SWEEP =
  "after:absolute after:inset-0 after:animate-skeleton-shine after:bg-[linear-gradient(90deg,var(--sk)_0%,var(--sk-shine)_20%,var(--sk-shine)_46%,var(--sk)_66%,var(--sk)_100%)] after:content-['']";

const SKELETON_BASE = `relative overflow-hidden rounded-lg bg-[var(--sk)] ${SHINE_SWEEP}`;

/** Default skeleton — sits on the page background. */
export const SKELETON = `${SKELETON_BASE} [--sk-shine:rgb(245_246_247/0.75)] [--sk:var(--color-gray-100)] dark:[--sk-shine:rgb(61_70_83/0.25)] dark:[--sk:var(--color-gray-700)]`;

/** One step darker — for skeletons sitting on a raised surface. */
export const SKELETON_DARK = `${SKELETON_BASE} [--sk-shine:rgb(237_238_240/0.5)] [--sk:var(--color-gray-200)] dark:[--sk-shine:rgb(29_35_44/0.15)] dark:[--sk:var(--color-gray-800)]`;
